/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ApiClient } from '../types/api/ApiClient';
import { SUJiraConfigGetResponse } from '../types/superuser/config/SUJiraConfigGetResponse';
import { SUJiraConfigUpdateRequest } from '../types/superuser/config/SUJiraConfigUpdateRequest';
import { getApiEndpoint } from '../utils/getApiEndpoint';
import { apiClientFactory } from '../utils/http-client/apiClientFactory';
import { axiosInstanceFactory } from '../utils/http-client/axiosInstanceFactory';
import { axiosJwtTokenInterceptor, axiosUnauthorizedInterceptor } from '../utils/http-client/axiosInterceptors';

class SUJiraConfigApiService {
  private api: ApiClient;

  constructor() {
    this.api = apiClientFactory(
      axiosInstanceFactory(
        { baseURL: getApiEndpoint() },
        [axiosJwtTokenInterceptor],
        [[undefined, axiosUnauthorizedInterceptor]],
      ),
    );
  }

  fetchConfig = () => {
    return this.api.get<SUJiraConfigGetResponse>('/administration/config/jira');
  };

  updateConfig = (data: SUJiraConfigUpdateRequest) => {
    return this.api.patch<SUJiraConfigUpdateRequest>('/administration/config/jira', data);
  };
}

export const SuperuserJiraConfigApiService = new SUJiraConfigApiService();
